import type { Preset, Timeframe } from "../types";
import type { Difficulty } from "./labeling";

/**
 * Difficulty presets → (m, N_max) — the single source of truth shared by the
 * build-time pipeline (to precompute per-preset labels) and the runtime (to
 * derive Higher/Lower labels live and to draw barrier lines). Per spec §4/§0,
 * Hard uses the widest barriers, Easy the narrowest.
 */
export const PRESETS: Record<Preset, Difficulty> = {
  easy: { m: 1.0, nMax: 10, atrPeriod: 14 },
  normal: { m: 2.0, nMax: 20, atrPeriod: 14 },
  hard: { m: 3.0, nMax: 30, atrPeriod: 14 },
};

export const PRESET_LIST: Preset[] = ["easy", "normal", "hard"];

/**
 * How many Context candles each timeframe's bank stores, mirroring the
 * pipeline's `contextLength` knobs (`dataPipeline/config.ts`, asserted equal
 * by `dataPipeline/config.test.ts`).
 *
 * The runtime needs it because the Context-length setting is a flat number of
 * candles across every timeframe (ADR-0013), and 50 candles is more than a
 * weekly or monthly Round carries. Selection clamps the requirement to what
 * the bank actually holds, so asking for 50 on weekly serves the whole 40
 * rather than filtering the bank down to nothing.
 */
export const BANK_CONTEXT_LENGTH: Record<Timeframe, number> = {
  daily: 50,
  weekly: 40,
  monthly: 36,
};

/**
 * Random-guess baseline (percent) — surfaced in the UI so a player reads
 * improvement over chance as skill (spec §7). Predict is Higher/Lower
 * everywhere, so chance is one number: ~1/2.
 */
export const BASELINE = 50;
